import { Component, OnInit, Inject } from '@angular/core';
import { Company } from 'app/modules/domain/models/company';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-delete-company',
  templateUrl: './delete-company.component.html',
  styleUrls: ['./delete-company.component.scss']
})
export class DeleteCompanyComponent implements OnInit {
  public company: Company;
  public deleteForm: FormGroup;

  constructor(public dialogRef: MdDialogRef<DeleteCompanyComponent>,
              @Inject(MD_DIALOG_DATA) public data: any,
              private formbuilder: FormBuilder) { }

  ngOnInit() {
    this.company = this.data.company;

    this.deleteForm = this.formbuilder.group({
      deleteToken: [ '', Validators.required ]
    });
  }

  public onCancelClick(): void  {
    this.dialogRef.close();
  }

  public onSaveClick(formData): void {
    this.dialogRef.close(formData.deleteToken);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/organisations/components/delete-company/delete-company.component.ts